import React, { useState } from 'react';
import { AppBar, Box, IconButton, alpha, useMediaQuery } from '@mui/material';
import { IHeader } from './interfaces';
import { UserMenu } from './components/UserMenu';
import { ModuleSelectorModal } from './components/ModuleSelectorModal';
import { PageContainer } from '../PageContainer';
import { useTenant } from '@context/TenantProvider';
import { apiRoute } from '@helpers/envHelper';
import MenuIcon from '@mui/icons-material/Menu';

export const Header: React.FC<IHeader> = ({
  onMobileMenuToggle,
}): JSX.Element => {
  const tenant = useTenant();
  const showMobileMenuBtn = useMediaQuery('(max-width: 1000px)');

  const [showModuleSelectorModal, setShowModuleSelectorModal] =
    useState<boolean>(false);

  const onModuleSelectorModalClose = (): void => {
    setShowModuleSelectorModal(false);
  };

  return (
    <AppBar
      position="sticky"
      sx={{
        zIndex: 1300,
        px: 2,
        py: { xs: '5px', md: 0 },
        backdropFilter: 'blur(8px)',
        background: alpha(tenant?.theme.header?.backgroundColor || '#FFF', 0.5),
      }}
    >
      <PageContainer
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          width: '100%',
          justifyItems: 'space-between',
        }}
      >
        {showMobileMenuBtn && (
          <IconButton onClick={onMobileMenuToggle}>
            <MenuIcon />
          </IconButton>
        )}

        <Box
          component="a"
          sx={{
            p: '5px',
          }}
        >
          <Box
            component="img"
            src={apiRoute(tenant?.theme.header?.logo)}
            sx={{
              maxHeight: { xs: 40, sm: 50, md: 60 },
              height: 'auto',
              display: 'block',
            }}
          />
        </Box>
        {/* <ModuleSelectorButton onClick={() => { setShowModuleSelectorModal(true); }} /> */}
        <ModuleSelectorModal
          show={showModuleSelectorModal}
          onClose={onModuleSelectorModalClose}
        />
        <UserMenu />
      </PageContainer>
    </AppBar>
  );
};
